/// <reference types="vite/client" />
import { initReceiver } from './receiver/receiver';
import { registerPlayerServices } from './playerServiceConfiguration';
import { initDatadogLogs } from './utils/initDatadogLogs';

if (import.meta.env.DEV) {
  // eslint-disable-next-line global-require
  (await import('@tv2/dev-remote-logging')).patchConsoleForRemoteLogging();
}

initDatadogLogs();

registerPlayerServices();

// noinspection JSIgnoredPromiseFromCall
initReceiver();
